module.exports = __webpack_public_path__ + "img/modal.dcda2123.jpg";